import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { LotType } from '../../../store/entities/lotTypes/lotTypes.types';
import { APIManagerConfig } from '../apiManager';

const LotMarketTypesServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getLotMarketTypes: (): Promise<LotType[]> =>
      HTTPBase.get(`farm/${config.farmId}/lotmarkettypes`).then((res) => res.data),
    createLotMarketType: (data: Partial<LotType>, formName: FormName): Promise<LotType[]> =>
      HTTPBase.post(`farm/${config.farmId}/lotmarkettypes`, data, { headers: { formName } }).then((res) => res.data),
    updateLotMarketType: (id: string, data: Partial<LotType>, formName: FormName): Promise<LotType[]> =>
      HTTPBase.patch(`farm/${config.farmId}/lotmarkettypes/${id}`, data, { headers: { formName } }).then(
        (res) => res.data,
      ),
    deleteLotMarketType: (id: string, formName: FormName): Promise<any> =>
      HTTPBase.delete(`farm/${config.farmId}/lotmarkettypes/${id}`, { headers: { formName } }).then((res) => res.data),
  };
};

export default LotMarketTypesServiceFactory;
